import { render, staticRenderFns } from "./footerBox.vue?vue&type=template&id=d01f5dec&"
var script = {}
import style0 from "./footerBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports